import { SyntheticEvent, useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { DoctorRoomAllocations } from "../components/DoctorAdmin";
import { Doctors } from "../components/DoctorAdmin";
import { Clinic } from "../models";
import { useLocation } from "react-router-dom";

export const DoctorAdmin = () => {
	const location = useLocation();
	const [value, setValue] = useState(0);
	const handleChange = (event: SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};
	const [clinic, setClinic] = useState<Clinic | undefined>(
		location.state?.clinic as Clinic | undefined
	);

	return (
		<>
			<Box
				sx={{
					borderBottom: 1,
					borderColor: "divider",
					marginBottom: 4,
					width: "fit-content"
				}}
			>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="Doctor Admin tabs"
				>
					<Tab label="Doctor Setup" />
					<Tab label="Room Allocation" />
				</Tabs>
			</Box>
			{value === 0 && <Doctors clinic={clinic} setClinic={setClinic} />}
			{value === 1 && (
				<DoctorRoomAllocations clinic={clinic} setClinic={setClinic} />
			)}
		</>
	);
};
